import { createSelector } from 'reselect';

const selectAllPhotos = state => state.photos.items || [];

const selectRequestStatus = state => state.photos.status;

const selectPhotosByProjectId = createSelector(
  selectAllPhotos,
  (state, projectId) => projectId,
  (photos, projectId) => photos.filter(photo => photo.projectId === projectId),
);

const selectCoverPhotos = createSelector(
  selectAllPhotos,
  photos => photos.filter(photo => photo?.isCover) || [],
);

export default {
  selectAllPhotos,
  selectRequestStatus,
  selectPhotosByProjectId,
  selectCoverPhotos,
};
